// The structure of the keys is not the same as the others because they were imported from a yml file.
// Apparently this was a legacy project using a different structure.

export default {
  next: 'Next',
  back: 'Back',
  kcal: 'kcal',
  gram: 'g',
  or: 'or',
  and: 'and',
  andIs: 'and is',
  orWeight: 'and has',
  weightKg: "Don't worry, if you don't know exactly, an estimate is enough.",
  year: 'Year',
  years: 'Years',
  month: 'Month',
  months: 'Months',
  'indefiniteArticle.male': 'a',
  'indefiniteArticle.female': 'a',
  'definiteArticle.male': 'the',
  'definiteArticle.female': 'the',
  'pronoun.male': 'he',
  'pronoun.female': 'she',
  'possessivePronoun.male': 'his',
  'possessivePronoun.female': 'her',
  'genderSuffix.male': '', // English doesn't typically use gender suffixes in this way
  'genderSuffix.female': '',
  'month.1': 'January',
  'month.2': 'February',
  'month.3': 'March',
  'month.4': 'April',
  'month.5': 'May',
  'month.6': 'June',
  'month.7': 'July',
  'month.8': 'August',
  'month.9': 'September',
  'month.10': 'October',
  'month.11': 'November',
  'month.12': 'December',
  'petName.message':
    'Tell us more about your pet so we can recommend the product that best suits you.',

  'input.petName.placeholder': 'Enter name',
  'input.petName.hint.min': 'Min. two letters',

  'input.dateOfBirth.description': "Don't worry, if you don't know exactly, an estimate is enough.",

  'input.weightKg.placeholder': 'Weight in kg',

  'input.allergies.description':
    '<b>Why is this important?</b> This tells us which foods to avoid in our recommendation.',
  'input.allergies.opt.beefordairy': 'Beef or dairy products',
  'input.allergies.opt.fish': 'Fish',
  'input.allergies.opt.grains': 'Grains',
  'input.allergies.opt.duck': 'Duck',
  'input.allergies.opt.chickenoreggs': 'Chicken or eggs',
  'input.allergies.opt.lamb': 'Lamb',
  'input.allergies.opt.potato': 'Potatoes',
  'input.allergies.opt.horse': 'Horse',
  'input.allergies.opt.goat': 'Goat',
  'input.allergies.opt.turkey': 'Turkey',
  'input.allergies.opt.none': 'None known',

  'input.otherAllergies.opt.kangaroo': 'Kangaroo',
  'input.otherAllergies.opt.deer': 'Deer',
  'input.otherAllergies.opt.buffalo': 'Buffalo',
  'input.otherAllergies.opt.wildBoar': 'Wild Boar',
  'input.otherAllergies.opt.insects': 'Insects',
  'input.otherAllergies.opt.sweetpotato': 'Sweet Potatoes',
  'input.otherAllergies.opt.peas': 'Peas',
  'input.otherAllergies.opt.pumpkin': 'Pumpkin',
  'input.otherAllergies.opt.carrot': 'Carrots',
  'input.otherAllergies.opt.parsnip': 'Parsnip',
  'input.otherAllergies.opt.zuchini': 'Zucchini',
  'input.otherAllergies.opt.broccoli': 'Broccoli',
  'input.otherAllergies.opt.amaranth': 'Amaranth',
  'input.otherAllergies.opt.quinoa': 'Quinoa',
  'input.otherAllergies.opt.buckwheat': 'Buckwheat',
  'input.otherAllergies.opt.other': 'The allergy is not listed here',
  'input.otherAllergies.placeholder': 'Other, enter here',

  'input.foodTypePreference.description':
    'You can select multiple options. Based on your selection, we will put together a suitable trial package for {petName}. ',
  'input.foodTypePreferences.opt.barf': 'BARF',
  'input.foodTypePreferences.opt.wetfood': 'Wet food',
  'input.foodTypePreferences.opt.dryfood': 'Dry food',
  'input.foodTypePreferences.opt.filetmenu': 'with fillet pieces',
  'input.foodTypePreferences.opt.mousse': 'light mousse consistency',
  'input.foodTypePreferences.opt.puremeat': 'lots of meat',
  'input.foodTypePreferences.opt.saucenmenu': 'Menu with lots of sauce',
  'input.foodTypePreferences.opt.none': 'Undecided',

  'input.foodTypePreferences.message':
    'Multiple options can be selected. If you are unsure or have no preferences, select all options.',
  'input.foodTypePreferences.description':
    '<b>Why is this important?</b> This allows us to take specific preferences into account when choosing food.',

  'input.catType.opt.indoor': 'A purely indoor cat',
  'input.catType.opt.outdoor': 'Outdoor cat',
  'input.isSpecificDisease.title': '',
  'input.isMeatIntolerance.title': '',
  'input.breed.description':
    '<b>Why is this important?</b> Some breeds have special needs that we want to consider in our food recommendation.',
  'input.breed.placeholder': 'Enter breed here',
  'checkbox:breed': "I don't know",

  'input.illnesses.description':
    '<b>Why is this important?</b> This helps us find the right food for {petText}.',
  'input.illnesses.opt.picky eater': 'Picky eater',
  'input.illnesses.opt.digestion': 'Digestion',
  'input.illnesses.opt.skin-fur': 'Skin & Fur',
  'input.illnesses.opt.low purine': 'Low purine',
  'input.illnesses.opt.diabetes': 'Diabetes',
  'input.illnesses.opt.osteoarthritis': 'Joints',
  'input.illnesses.opt.storage mites': 'Storage mites',
  'input.illnesses.opt.struvite stones': 'Struvite stones',
  'input.illnesses.opt.renal or liver failure': 'Kidney or liver',
  'input.illnesses.opt.gastro intestinal issues or pancreatitis': 'Gastrointestinal / Pancreatitis',
  'input.illnesses.opt.other': 'Not listed',
  'input.illnesses.opt.none': 'None known',

  'input.weightGoal.opt.lose': 'Underweight',
  'input.weightGoal.opt.maintain': 'Ideal weight',
  'input.weightGoal.opt.gain': 'Overweight',

  'input.name.description':
    'Tell us your name so we can create a personalized feeding recommendation for {petName}.',
  'input.ownerFirstName.placeholder': 'First name',
  'input.ownerFirstName.label': 'Your first name',
  'input.ownerFirstName.hint.min': 'Looks a bit short.',
  'input.ownerLastName.label': 'Your last name',
  'input.ownerLastName.placeholder': 'Last name',
  'input.ownerLastName.hint.min': 'Looks a bit short.',

  'input.ownerEmail.placeholder': 'your@email.com',
  'input.ownerEmail.description':
    "Yay! We've found the right match for {petText}! Now just leave your email so we can send you the results.",
  'input.ownerEmail.hint.email': 'Please enter a valid email address',
  'input.neutered.opt.true': 'Yes',
  'input.neutered.opt.false': 'No',
  'input.gender.opt.female': 'Female',
  'input.gender.opt.male': 'Male',

  'evaluation.title': 'Personal feeding plan for <strong>{petName}</strong>',
  'evaluation.loading': 'Loading...',
  'evaluation.description':
    '{petName} needs an average of approx. {foodTypes} of the selected Pets Deli varieties. This food requirement is based on the energy and nutrient values of the selected Pets Deli varieties.',
  'evaluation.table.dailyKcal': '{petName} calorie requirement',
  'evaluation.table.factor': 'Factor',
  'evaluation.table.caloryRequirements': 'Calories',
  'evaluation.table.RER': 'Resting energy expenditure',
  'evaluation.table.RER.description':
    'This describes the basal metabolic rate of your pet, i.e. how much energy your pet burns approximately at rest or with little to no activity.',
  'evaluation.table.neutered': 'Neutering',
  'evaluation.table.neutered.description':
    'In neutered animals, hormone activity decreases somewhat and metabolism slows down as a result. This means your pet consumes slightly less energy, i.e. food, than an unneutered animal.',
  'evaluation.table.temper': 'Temperament',
  'evaluation.table.temper.description':
    "Temperament significantly reflects an animal's activity level. Depending on how much your furry friend moves, more or less energy is needed to maintain body function.",
  'evaluation.foodType.barf': 'BARF',
  'evaluation.foodType.wetfood': 'Wet food',
  'evaluation.foodType.dryfood': 'Dry food',
  'evaluation.foodType.none': 'Undecided',
  'evaluation.suggestionsTitle': 'And we also recommend:',
  'evaluation.suggestionsSubtitle': 'Just add the right products for you to your cart.',
  'evaluation.button.trySelection': 'Try selection!',
  'evaluation.otherPopularProducts.title': 'Other popular products',
  'suggestions.title': 'Our recommendation for {petName}:',
  'suggestion.title': 'Our recommendation',
  'product.more': 'Learn More',
  'product.toTry': 'To try',
  'product.deliveryTime': '1-2 days',
  'product.add': 'Add to cart',
  'results.temper.lazy': 'less active',
  'results.temper.quiet': 'quiet',
  'results.temper.average': 'average',
  'results.temper.active': 'active',
  'results.temper.restless': 'very active',
  'results.neutered.female': 'neutered',
  'results.neutered.male': 'neutered',
  'results.description':
    "{petName} is {indefiniteArticle} {temper}{genderSuffix} {neutered} {breed}. For a balanced diet, {pronoun} needs about {kcal} kcal per day to maintain {possessivePronoun} weight – that's roughly {foodTypes}.",
  'results.table.title': '{possessivePetName} requirements',
  'results.table.subtitle': 'based on the information provided',
  'results.next': 'To your products',

  'wizard.title.petName': "What is your pet's name?",
  'wizard.title.breed': 'What breed is {petName}?',
  'wizard.title.dateOfBirth': 'When was {petName} born?',
  'wizard.title.weightKg': 'How much does {petName} weigh?',
  'wizard.title.allergies': 'Is there a known food allergy? If so, which one:',
  'wizard.title.illnesses': 'What problem does {petName} have?',
  'wizard.title.foodTypePreferences': 'What should {petName} get?',
  'wizard.title.ownerEmail': 'What is your email address?',
  'wizard.title.neutered': 'Is {petName} neutered?',
  'wizard.title.gender': 'What gender is {petName}?',

  'foodaid:page-title': 'Food Advisor',

  'foodaid:questions:policy-1': 'By submitting your data, you agree to our',
  'foodaid:questions:policy-2': 'Terms & Conditions',
  'foodaid:questions:policy-3': 'Privacy Policy',
  'foodaid:questions:policy-4':
    'and to occasionally receive information from Pets Deli about suitable products for your pet.',

  'foodaid:evaluation:item-added-to-cart': '✓ ADDED!',
  'foodaid:evaluation:sub-title': 'Simply add the products that suit you to the cart!',
  'foodaid:evaluation:results': '{count, number} {count, plural, one {Result} other {Results}}',
  'foodaid:evaluation:our-categories': 'Our category',

  'foodaid:results:extended-title': 'Suitable products for {petName}',
  'foodaid:results:title': 'Suitable products',
  'foodaid:lazy-input:pet-name-input-dog': "Your doggo's name",
  'foodaid:lazy-input:pet-name-input-cat': "Your kitty's name",
  'foodaid:lazy-input:create-nutrition-plan': 'Start',
  'foodaid:support:title':
    "Special pets deserve tailored advice – and that's exactly what we offer.",
  'foodaid:support:description':
    'It looks like {petName} has specific needs. Our experts are here for you! Contact us via:',
  'foodaid:support:schedule-appointment':
    'Our advisors will contact you / Our advisors will call you at the agreed time',
  'foodaid:support:button:phone': 'Phone',
  'foodaid:support:button:email': 'Email',
  'foodaid:support:button:whatsapp': 'WhatsApp',
  'foodaid:support:button:home': 'Home',

  'foodaid:loading-screen:loading': 'Loading...',
  'foodaid:loading-screen:title': "We'll be right there with the perfect food for {petName}!",
  'foodaid:loading-screen:description-1':
    'While you wait: Did you know that some dogs are faster than cheetahs?',
  'foodaid:loading-screen:description-2':
    "A dog's sense of smell is at least 40x better than ours.",
  'foodaid:questions:case-data:petName': 'Name',
  'foodaid:questions:case-data:allergies': 'Food allergy',
  'foodaid:questions:case-data:otherAllergies': 'Other allergies',
  'foodaid:questions:case-data:breed': 'Breed',
  'foodaid:questions:case-data:dateOfBirth': 'Date of birth',
  'foodaid:questions:case-data:weightKg': 'Weight',
  'foodaid:questions:case-data:weightGoal': 'Weight goal',
  'foodaid:questions:case-data:illnesses': 'Illnesses',
  'foodaid:questions:case-data:foodTypePreferences': 'Food type',
  'foodaid:questions:case-data:ownerEmail': 'Email',
  'foodaid:questions:case-data:gender': 'Gender',
  'foodaid:questions:case-data:neutered': 'Neutered',

  'foodaid:nutritional-plan:header:title': 'Tailored to your taste.',
  'foodaid:nutritional-plan:header:sub-title':
    "You have special needs - we have the right food. Let's create the perfect menu for {petName} together.",
  'foodaid:nutritional-plan:header:pet-name': '{petName} needs',
  'foodaid:nutritional-plan:header:kcalsperday': '{kcalsPerDay} kcal/day',
  'foodaid:nutritional-plan:header:icon-title-1': 'Suitable for {petName}',
  'foodaid:nutritional-plan:header:icon-title-2': ' Fresh ingredients for the best taste',
  'foodaid:nutritional-plan:header:icon-title-3': 'Without grain & sugar',
  'foodaid:nutritional-plan:product-description':
    'Product information, ingredients, vitamins, quantities & trace elements and feeding recommendations <a>show</a>',
  'foodaid:nutritional-plan:added-to-cart': 'Add to cart',
  'foodaid:nutritional-plan:in-cart': 'In cart',
  'foodaid:nutritional-plan:remove-product': 'Remove',
};
